import { combineReducers, createStore } from 'redux';
import { paginationReducer } from '../../pages/arc/shared-slices/pagination-slice';
import { SearchAppState } from '../search-model';
import { searchReducer } from '../search-slice';

let storeDictionary: { [key: string]: any } = {};

const initializeNewStore = () => {
	const stateReducer = combineReducers<SearchAppState>({
		searchState: searchReducer,
		paginationState: paginationReducer,

	});

	return createStore(stateReducer);
};

export const getSearchStore = (searchAppName: string) => {	
	let store = storeDictionary[searchAppName];
	if (!store) {
		store = initializeNewStore();
		storeDictionary[searchAppName] = store;
	}
	return store;
};

export const cleanSearchStores = () => {
	storeDictionary = {};	
};
